import apiClient from './client';

export const listNotifications = (params) => apiClient.get('/notifications', { params }).then((r) => r.data);
export const markNotificationRead = (id) => apiClient.patch(`/notifications/${id}/read`).then((r) => r.data);
export const markAllNotificationsRead = () => apiClient.patch('/notifications/read-all').then((r) => r.data);
